import { produce } from "immer";
import { isBoolean, isEqual } from "lodash";
import { action } from "nanostores";

import { $visualizer } from "@/stores/visualizer";

import type { HDAluProps } from "@/utils/constants/hdAluProps";

export const selectHdAlu = action(
  $visualizer,
  "select hdalu",
  (store, { display, treatmentOptions, frameOptions, finish }) => {
    const newSelectedHDAlu = produce(
      store.get().options,
      (draft: HDAluProps) => {
        if (isBoolean(display)) draft.display = display;

        if (frameOptions) {
          draft.frameOptions = { ...draft.frameOptions, ...frameOptions };
        }

        if (finish) {
          draft.finish = finish;
        }

        if (treatmentOptions) {
          draft.treatmentOptions = {
            ...draft.treatmentOptions,
            ...treatmentOptions,
          };
        }
      }
    );

    if (!isEqual(newSelectedHDAlu, store.get().options)) {
      store.setKey("options", newSelectedHDAlu);
    }
  }
);
